(() => {
  const formatMoney = (cents) => {
    const currency = document.documentElement.dataset.currency || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const initProduct = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dataNode = root.querySelector('[data-product-json]');
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!dataNode || !form) return;

    let product;
    try { product = JSON.parse(dataNode.textContent); } catch (_) { return; }

    const variantInput = form.querySelector('[name="id"]');
    const button = form.querySelector('[name="add"]');
    const buttonText = button && button.querySelector('[data-add-text]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const selects = [...root.querySelectorAll('[data-option-position]')];

    const update = () => {
      const values = selects.map((select) => select.value);
      const variant = product.variants.find((item) => item.options.every((option, index) => option === values[index]));
      if (!variant) return;

      variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? buttonText.dataset.available : buttonText.dataset.soldOut;

      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };

    selects.forEach((select) => select.addEventListener('change', update));
  };

  const initNavigation = (root) => {
    if (root.dataset.navigationInitialized === 'true') return;
    root.dataset.navigationInitialized = 'true';

    const dropdowns = [...root.querySelectorAll('[data-nav-dropdown]')];
    const closeDesktopDropdowns = () => {
      root.querySelectorAll('.desktop-nav [data-nav-dropdown][open]').forEach((details) => {
        details.removeAttribute('open');
      });
    };

    dropdowns.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;

        const item = details.parentElement;
        const siblingItems = item?.parentElement?.children || [];
        [...siblingItems].forEach((sibling) => {
          if (sibling === item) return;
          const siblingDropdown = sibling.querySelector(':scope > [data-nav-dropdown][open]');
          siblingDropdown?.removeAttribute('open');
        });
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openDropdowns = [...root.querySelectorAll('details[open]')];
      if (!openDropdowns.length) return;

      const focusedDropdown = [...openDropdowns].reverse().find((details) => details.contains(document.activeElement));
      const dropdown = focusedDropdown || openDropdowns[openDropdowns.length - 1];
      const summary = dropdown.querySelector(':scope > summary');
      dropdown.removeAttribute('open');
      summary?.focus();
      event.preventDefault();
      event.stopPropagation();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeDesktopDropdowns();
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-root]').forEach(initProduct);
    scope.querySelectorAll('[data-site-header]').forEach(initNavigation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
